import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { adminApi } from "./api";

const TILES = [
  { key: "new", label: "New enquiries" },
  { key: "in_review", label: "In review" },
  { key: "contacted", label: "Contacted" },
  { key: "closed", label: "Closed" },
];

export default function Dashboard() {
  const [counts, setCounts] = useState({ new: 0, in_review: 0, contacted: 0, closed: 0 });
  const [integ, setInteg] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    Promise.all([adminApi.listEnquiries({ page: 1, page_size: 1 }), adminApi.integrationStatus()])
      .then(([e, i]) => {
        setCounts(e.data.counts);
        setInteg(i.data);
      })
      .finally(() => setLoading(false));
  }, []);

  return (
    <div className="ga-page" data-testid="dashboard-page">
      {integ && integ.email_delivery === "not_configured" && (
        <div className="ga-banner" data-testid="email-banner">
          <span className="ga-banner__dot" aria-hidden="true" />
          Email notifications are disabled by owner decision. Enquiries are stored here and must be checked
          regularly — no outbound emails will be sent.
        </div>
      )}

      <div className="ga-eyebrow">Dashboard</div>
      <h1 className="ga-title">Enquiries overview</h1>

      <div className="ga-tiles" data-testid="tiles">
        {TILES.map((t) => (
          <Link
            to={`/admin/enquiries?status=${t.key}`}
            key={t.key}
            className="ga-tile"
            data-testid={`tile-${t.key}`}
          >
            <div className="ga-tile__num">{loading ? "…" : counts[t.key]}</div>
            <div className="ga-tile__label">{t.label}</div>
          </Link>
        ))}
      </div>

      <div className="ga-shortcuts">
        <Link to="/admin/enquiries" className="ga-link" data-testid="shortcut-enquiries">
          Open enquiries inbox <span>→</span>
        </Link>
        <Link to="/admin/content" className="ga-link" data-testid="shortcut-content">
          Edit page content <span>→</span>
        </Link>
      </div>
    </div>
  );
}
